import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PhoneNumberInput } from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import { ReferralPreRegistrationService } from '@mpt-fo/common/core/services/referral-pre-registration.service';
import { InputPatterns } from '@mpt-fo/common/shared/utils/input-patterns.constant';
@Component({
	selector: 'app-joining-form',
	templateUrl: './joining-form.component.html',
	styleUrls: ['./joining-form.component.scss']
})
export class JoiningFormComponent implements OnInit {
	phone: PhoneNumberInput;
	form: FormGroup;
	submitting = false;
	isAPISucessfull = false;
	isMobile = false;
	platform = 'Android';
	@Input() referralCode: string;
	@Input() is404 = false;
	readonly breakPoint = 900;
	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}
	constructor(private referralPreRegistrationService: ReferralPreRegistrationService) {

	}

	ngOnInit(): void {
		this.setMobile(window.innerWidth);
		this.platform = this.getPlatform();
		this.initializePhoneInput();
		this.form = new FormGroup({
			phoneNumber: this.phone.getFormGroupControl()
		});
	}

	initializePhoneInput(): void {
		this.phone = new PhoneNumberInput("", "Phone Number", true, null, InputPatterns.NIGERIA_MOBILE_NO)
		this.phone.setShowInputStateSuffix(true);
		this.phone.setShowCharCount(true);
		this.phone.setMinLength(11);
		// this.phone.regexValidator(InputPatterns.NIGERIA_MOBILE_NO)
	}

	submitForm(): void {
		if (this.is404) {
			this.referralPreRegistrationService.openApplicationStore(this.referralCode);
		} else {
			if(this.isAPISucessfull){
				this.referralPreRegistrationService.openApplicationStore(this.referralCode);
				return;
			}
			this.submitting = true;
			if (this.form.valid) {
				const data = {
					"phoneNumber": this.replaceCharAt(this.form.value.phoneNumber, 0, '234'),
					"referralCode": this.referralCode
				};
				// .pipe(
				// 	finalize(() => {
				// 		this.submitting = false;
				// 	})
				// )
				this.referralPreRegistrationService.postReferralPreRegistrations(data)
				.subscribe(data => {
					this.submitting = false;
					this.isAPISucessfull = true;
					this.referralPreRegistrationService.openApplicationStore(this.referralCode);
				}, error => {
					this.submitting = false;
				})
			}
		}
	}

	replaceCharAt(str: string, index: number, replacement: string): string {
		if (index < 0 || index >= str.length) {
			return str;
		}

		return str.substring(0, index) + replacement + str.substring(index + 1);
	}


	getPlatform() {
		if (/Android/i.test(navigator.userAgent)) {
			return "Android";
		} else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
			return "iOS";
		} else {
			return "Android";
		}
	}

	setMobile(browserWidth) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	onPhoneNumberChange(event) {
		}

	get isValid(){
		return this.form.valid && this.phone?.validate();
	}

}
